export function isRunAtWeCom() {
  const ua = navigator.userAgent.toLowerCase();
  return /wxwork/i.test(ua);
}
